import Utils from 'src/utils';
import { edeApi } from 'src/api';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';
const CARDS = 'Cards';
const CARD_TYPES = 'CardTypes';
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["LOAD_CARDS"] = "LOAD_CARDS";
    ActionTypes["LOAD_CARD_TYPES"] = "LOAD_CARD_TYPES";
    ActionTypes["POST_CARD"] = "POST_CARD";
    ActionTypes["PUT_CARD"] = "PUT_CARD";
    ActionTypes["DELETE_CARD"] = "DELETE_CARD";
})(ActionTypes || (ActionTypes = {}));
const saveOfflineLockCards = (list) => ({
    type: ActionTypes.LOAD_CARDS,
    payload: list
});
const addOfflineLockCard = (newCard) => ({
    type: ActionTypes.POST_CARD,
    payload: newCard
});
const updateOfflineLockCard = (editedCard) => ({
    type: ActionTypes.PUT_CARD,
    payload: editedCard
});
const removeOfflineLockCard = (deletedCardId) => ({
    type: ActionTypes.DELETE_CARD,
    payload: deletedCardId
});
const saveOfflineLockCardTypes = (list) => ({
    type: ActionTypes.LOAD_CARD_TYPES,
    payload: list
});
export function loadOfflineLockCards(reqParams) {
    return (dispatch) => communicate({
        url: CARDS,
        method: 'get',
        getParams: Utils.objects.objectToQueryString(reqParams)
    })
        .then(({ data }) => data?.Data)
        .then((list = []) => {
        dispatch(saveOfflineLockCards(list));
        return Promise.resolve(list);
    })
        .catch((error) => {
        dispatch(saveOfflineLockCards([]));
        toastrError(error);
        return Promise.reject();
    });
}
export function loadOfflineLockCardTypes() {
    return (dispatch) => communicate({
        url: CARD_TYPES,
        method: 'get'
    })
        .then(({ data }) => data?.Data)
        .then((list = []) => {
        dispatch(saveOfflineLockCardTypes(list));
        return Promise.resolve(list);
    })
        .catch((error) => {
        dispatch(saveOfflineLockCardTypes([]));
        toastrError(error);
        return Promise.reject();
    });
}
export function postOfflineLockCard(payload) {
    return (dispatch) => communicate({
        url: CARDS,
        method: 'post',
        data: payload
    })
        .then((response) => {
        toastrSuccess(response);
        const newCard = response.data.Data;
        dispatch(addOfflineLockCard(newCard));
        return Promise.resolve(newCard);
    })
        .catch((error) => {
        toastrError(error);
        return Promise.reject();
    });
}
export function putOfflineLockCard(payload) {
    return (dispatch) => communicate({
        url: CARDS,
        method: 'put',
        data: payload
    })
        .then((response) => {
        toastrSuccess(response);
        const updatedCard = response.data.Data;
        dispatch(updateOfflineLockCard(updatedCard));
        return Promise.resolve(updatedCard);
    })
        .catch((error) => {
        toastrError(error);
        return Promise.reject();
    });
}
export function deleteOfflineLockCard(id) {
    return (dispatch) => communicate({
        url: CARDS,
        method: 'delete',
        getParams: Utils.objects.objectToQueryString({ id })
    })
        .then((response) => {
        toastrSuccess(response);
        dispatch(removeOfflineLockCard(id));
        return Promise.resolve();
    })
        .catch((error) => {
        toastrError(error);
        return Promise.reject();
    });
}
export function importOfflineLockCards(payload) {
    return () => edeApi.eduId.importSchoolCardsCreate(payload)
        // @ts-ignore
        .then((response) => Promise.resolve(response.data.Data))
        .catch((error) => {
        const errorMsg = error.response?.data?.resultMsg || error.message || error.code;
        return Promise.reject(errorMsg);
    });
}
export function importOfflineLockCardTypes(payload) {
    return () => edeApi.eduId.importCardTypesCreate(payload)
        // @ts-ignore
        .then((response) => Promise.resolve(response.data.Data))
        .catch((error) => {
        const errorMsg = error.response?.data?.resultMsg || error.message || error.code;
        return Promise.reject(errorMsg);
    });
}
